import { Button as AntdButton } from 'antd';
import styled from 'styled-components';

const Button = styled(AntdButton).withConfig({
    shouldForwardProp: prop => !['porscheFallbackIcon', 'porscheFallbackIconSource', 'showIcon'].includes(prop),
})`
    &.ant-btn {
        min-width: 70px;
        height: 52px;
        border-radius: 25px;
        font-size: var(--button-font-size, 1rem);
        text-transform: lowercase;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        & span {
            pointer-events: none;
            line-height: 16px;
            height: 16px;
        }

        & .anticon {
            font-size: inherit;
        }

        /* ensure capitalizing the 1st letter */
        & > span:not([role='img'])::first-letter {
            text-transform: capitalize;
        }

        &.ant-btn-secondary {
            background-color: var(--ant-primary-color);
            border-color: var(--ant-primary-color);
            color: #fff;

            &:hover {
                border-color: #373737;
            }
        }

        &.ant-btn-link {
            border: none;
            width: fit-content;
            min-width: initial;
            border-color: transparent;

            > svg {
                fill: currentColor;
            }

            > svg + span {
                margin-left: 8px;
                margin-top: 2px;
            }
        }

        ${({ size = 'large' }) =>
            size === 'large' &&
            `
                min-width: 180px;
            `}
    }
`;

export default Button;
